import React from 'react';
import PropTypes from 'prop-types';
import { ToggleButton } from '@mui/material';

import { StyledToggleButtonGroup as StyledToggleButtonGroupRoot } from './styles';

const ToggleButtonGroup = ({
  value,
  options,
  onChange,
  size,
  exclusive,
  disabled,
}) => (
  <StyledToggleButtonGroupRoot
    value={value}
    onChange={(_, selectedValue) => selectedValue !== null && onChange(selectedValue)}
    size={size}
    exclusive={exclusive}
    disabled={disabled}
  >
    {options.map(({ value: optionValue, label }) => (
      <ToggleButton key={optionValue} value={optionValue}>
        {label}
      </ToggleButton>
    ))}
  </StyledToggleButtonGroupRoot>
);

ToggleButtonGroup.propTypes = {
  value: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  })).isRequired,
  onChange: PropTypes.func.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  exclusive: PropTypes.bool,
  disabled: PropTypes.bool,
};

ToggleButtonGroup.defaultProps = {
  size: 'small',
  exclusive: true,
  disabled: false,
};

export default ToggleButtonGroup;
